import { render, staticRenderFns } from "./ventafielTecnology.vue?vue&type=template&id=5b0afdfe&scoped=true&"
import script from "./ventafielTecnology.vue?vue&type=script&lang=js&"
export * from "./ventafielTecnology.vue?vue&type=script&lang=js&"
import style0 from "./ventafielTecnology.vue?vue&type=style&index=0&id=5b0afdfe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0afdfe",
  null
  
)

export default component.exports